import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetSalesRepReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    page: 1,
    limit: 50,
    search: '',
    sort_by: 'total_shipping/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
    sales_rep_type: '',
  }

  const {filters, onSearch, onSortingChange, onPageChange, onDateChange, setMultipleFilters} =
    useFilters(initialFilters, {sortType: 'number'})

  const {data: response, isFetching} = Api.useGetQuery('/analytics/shipping-report/sales-rep', {
    queryId: 'shipping-sales-rep-report',
    filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeSalesRepTypeFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_type: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    handleSalesRepReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
    onChangeSalesRepTypeFilter,
  }
}

export default useGetSalesRepReport
